export function byId<T extends HTMLElement>(id: string): T {
  const element = document.getElementById(id);
  if (element === null) throw new Error(`No se encontró el elemento #${id} en el DOM.`);
  return element as T;
}

export interface CreateOptions {
  className?: string;
  text?: string;
  title?: string;
}

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  options: CreateOptions = {},
): HTMLElementTagNameMap[K] {
  const element = document.createElement(tag);
  if (options.className !== undefined) element.className = options.className;
  if (options.text !== undefined) element.textContent = options.text;
  if (options.title !== undefined) element.title = options.title;
  return element;
}

export function clear(element: Element): void {
  while (element.firstChild !== null) element.removeChild(element.firstChild);
}

export function setText(element: Element, text: string): void {
  if (element.textContent !== text) element.textContent = text;
}

export function setHidden(element: HTMLElement, hidden: boolean): void {
  if (element.hidden !== hidden) element.hidden = hidden;
}

export function setBusy(button: HTMLButtonElement, busy: boolean): void {
  button.disabled = busy;
  if (busy) button.setAttribute("aria-busy", "true");
  else button.removeAttribute("aria-busy");
}

const SVG_NS = "http://www.w3.org/2000/svg";

export function icon(name: string, className = "icon"): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("class", className);
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  const use = document.createElementNS(SVG_NS, "use");
  use.setAttribute("href", `#${name}`);
  svg.append(use);
  return svg;
}
